import { useMemo } from 'react'
import { useContentTypeCosts, type ContentTypeCosts } from 'hooks/useContentTypeCosts'
import { CONTENT_CATEGORIES, type ContentCategory } from 'utils/brandPlans/contentCategories'

const CATEGORY_TO_COST_KEY: Record<ContentCategory, keyof ContentTypeCosts> = {
  still_image_post: 'stillImage',
  carousel_post: 'carousel',
  feed_video_post: 'feedVideo',
  short_form_video: 'shortFormVideo',
  avatar_video: 'shortFormVideo',
  stories: 'story',
  blog_post: 'blog',
  newsletter: 'email',
}

export const useCategoryCreditCosts = (
  options?: Parameters<typeof useContentTypeCosts>[0],
): Record<ContentCategory, number> => {
  const typeCosts = useContentTypeCosts(options)

  return useMemo(() => {
    const result = {} as Record<ContentCategory, number>
    for (const category of CONTENT_CATEGORIES) {
      result[category] = typeCosts[CATEGORY_TO_COST_KEY[category]]
    }
    return result
  }, [typeCosts])
}
